/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Map_TitleInputs */

const en_automation_map_title = /** @type {(inputs: Automation_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flow map`)
};

const pt_br2_automation_map_title = /** @type {(inputs: Automation_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa do fluxo`)
};

/**
* | output |
* | --- |
* | "Flow map" |
*
* @param {Automation_Map_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_map_title = /** @type {((inputs?: Automation_Map_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Map_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_map_title(inputs)
	return pt_br2_automation_map_title(inputs)
});